import { gql } from 'graphql-request';

export const GET_USER_QUERY = gql`
  query GetUser ($id: ID!) {
    getUser(id: $id) {
      id,
      answers,
      busFinder,
      email,
      phone,
      name,
      companyName,
    }
  }
`;

export const COMPLETE_USER = gql`
  mutation CompleteUser(
    $id: ID!,
    $name: String!,
    $companyName: String,
    $email: String!,
    $phone: String,
    $newsletter: Boolean!;
    $answers: AWSJSON,
    $busFinder: AWSJSON,
    $outcome: String!,
    $partner: String;
  ) {
    completeUser(
      input: {
        id: $id,
        name: $name,
        companyName: $companyName,
        email: $email,
        phone: $phone,
        newsletter: $newsletter,
        answers: $answers,
        busFinder: $busFinder,
        outcome: $outcome,
        partner: $partner,
      }
    )
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser {
    createUser {
      id
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: ID!,
    $answers: AWSJSON,
    $busFinder: AWSJSON,
  ) {
    updateUser(
      input: {
        id: $id,
        answers: $answers,
        busFinder: $busFinder,
      }
    ) {
      id
    }
  }
`;

export const UPDATE_USER_OUTCOME = gql`
  mutation UpdateUserOutcome(
    $id: ID!,
    $outcome: String!,
  ) {
    updateUserOutcome(
      input: {
        id: $id,
        outcome: $outcome,
      }
    ) {
      id
    }
  }
`;

export const COMPLETE_BUS_FINDER = gql`
  mutation CompleteBusFinder (
    $id: ID!,
    $busFinderOutcome: String!,
    $name: String!,
    $companyName: String,
    $email: String!,
    $phone: String,
    $busFinderCall: Boolean!,
    $busFinder: AWSJSON,
  ) {
    completeBusFinder(
      input: {
        id: $id,
        busFinderOutcome: $busFinderOutcome,
        name: $name,
        companyName: $companyName,
        email: $email,
        phone: $phone,
        busFinderCall: $busFinderCall,
        busFinder: $busFinder,
      }
    ) 
  }
`;
